import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { BsLightningChargeFill } from "react-icons/bs";

import { useLoggedInUser } from "@/components/providers/ApiProvider/hooks";
import {
  marketingButtonClass,
  type MarketingButtonVariant,
} from "./marketingButtonClass";

export function Bolt() {
  return <BsLightningChargeFill aria-hidden className="size-4 text-teal-500" />;
}

type StartFreeButtonProps = {
  children: ReactNode;
  variant?: MarketingButtonVariant;
  className?: string;
  /** Shows the bolt before the label, as on the hero CTAs. */
  bolt?: boolean;
};

/** Sign up when logged out, Audiolab when logged in. */
export function StartFreeButton({
  children,
  variant = "primary",
  className,
  bolt = true,
}: StartFreeButtonProps) {
  const { data: user } = useLoggedInUser();
  const classes = marketingButtonClass(variant, className);
  const content = (
    <>
      {bolt && <Bolt />}
      {children}
    </>
  );

  if (user) {
    return (
      <Link to="/audiolab" className={classes}>
        {content}
      </Link>
    );
  }
  return (
    <Link
      to="."
      search={(prev) => ({ ...prev, auth: "signup" as const })}
      resetScroll={false}
      className={classes}
    >
      {content}
    </Link>
  );
}

type MarketingLinkProps = {
  to: string;
  className?: string;
  children: ReactNode;
  "aria-label"?: string;
};

/** Links to the marketing routes, which are added across several PRs. */
export function MarketingLink({ to, ...props }: MarketingLinkProps) {
  return <Link to={to as never} {...props} />;
}
